/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

// tslint:disable:max-classes-per-file
import { Action } from '@ngrx/store';

export const GET_LIBRARY_UPLOADED_GAMES = '[Library] Get Library Uploaded Games';
export const GET_LIBRARY_UPLOADED_GAMES_FAIL = '[Library] Get Library Uploaded Games Success';
export const GET_LIBRARY_UPLOADED_GAMES_SUCCESS = '[Library] Get Library Uploaded Games Fail';

export class GetLibraryUploadedGames implements Action {
  readonly type = GET_LIBRARY_UPLOADED_GAMES;

  constructor(public payload: any) {}
}

export class GetLibraryUploadedGamesFail implements Action {
  readonly type = GET_LIBRARY_UPLOADED_GAMES_FAIL;

  constructor(public payload: any) {}
}

export class GetLibraryUploadedGamesSuccess implements Action {
  readonly type = GET_LIBRARY_UPLOADED_GAMES_SUCCESS;

  constructor(public payload: any) {}
}

// action types
export type GetLibraryUploadedGamesAction =
  | GetLibraryUploadedGames
  | GetLibraryUploadedGamesFail
  | GetLibraryUploadedGamesSuccess;
